/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { SuccessResponseDataFromJSON, SuccessResponseDataToJSON } from './SuccessResponseData';
export function BulkDestroyDocumentsResponseFromJSON(json) {
    return BulkDestroyDocumentsResponseFromJSONTyped(json, false);
}
export function BulkDestroyDocumentsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        status: !exists(json, 'status') ? undefined : json['status'],
        data: !exists(json, 'data') ? undefined : SuccessResponseDataFromJSON(json['data'])
    };
}
export function BulkDestroyDocumentsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        status: value.status,
        data: SuccessResponseDataToJSON(value.data)
    };
}
